/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class StoryAPI
 * @hideconstructor
 * @classdesc API class that is used to control the behaviour of a storytelling instance
 */
define([], () => {
	class StoryAPI {
		/**
		 * @function StoryAPI#addScene
		 * @param {string} [sceneType=SceneLayout1]
		 * @param {string} [title=null]
		 */
		addScene(sceneType, title) {
			void(sceneType);
			void(title);
		}

		/**
		 * @function StoryAPI#deleteScene
		 * @param id
		 */
		deleteScene(id) {
			void(id);
		}

		/**
		 * @function StoryAPI#duplicateScene
		 * @param id
		 */
		duplicateScene(id) {
			void(id);
		}

		/**
		 * @function StoryAPI#enterShareState
		 * @param slideout {Object} The share panel slideout
		 */
		enterShareState(slideout) {
			void(slideout);
		}

		/**
		 * @function StoryAPI#getCurrentSceneInfo
		 */
		getCurrentSceneInfo() {}

		/**
		 * @function StoryAPI#getCurrentTime
		 */
		getCurrentTime() {}

		/**
		 * @function StoryAPI#getDuration
		 */
		getDuration() {}

		/**
		 * @function StoryAPI#getSceneCount
		 */
		getSceneCount() {}

		/**
		 * @function StoryAPI#getSelectedSceneIndex
		 */
		getSelectedSceneIndex() {}

		/**
		 * @function StoryAPI#getSceneId
		 * @param index
		 */
		getSceneId(index) {
			void(index);
		}

		/**
		 * @function StoryAPI#getTimelineAPI
		 * @param index
		 */
		getTimelineAPI() {}

		/**
		 * @function StoryAPI#isPlaying
		 */
		isPlaying() {}

		/**
		 * @function StoryAPI#isStartOverview
		 */
		isStartOverview() {}

		/**
		 * @function StoryAPI#isEndOverview
		 */
		isEndOverview() {}

		/**
		 * @function StoryAPI#isAtStartOfScene
		 */
		isAtStartOfScene() {}

		/**
		 * @function StoryAPI#isAtEndOfScene
		 */
		isAtEndOfScene() {}

		/**
		 * @function StoryAPI#toggleKioskMode
		 */
		toggleKioskMode() {}

		/**
		 * @function StoryAPI#toggleNavigateMarkers
		 */
		toggleNavigateMarkers() {}

		/**
		 * @function StoryAPI#togglePlayThrough
		 */
		togglePlayThrough() {}

		/**
		 * @function StoryAPI#isNavigateMarkers
		 */
		isNavigateMarkers() {}

		/**
		 * @function StoryAPI#isScenePopulated
		 * @param sceneId
		 */
		isScenePopulated(sceneId) {
			void(sceneId);
		}

		/**
		 * @function StoryAPI#play
		 */
		play() {}

		/**
		 * @function StoryAPI#stop
		 */
		stop() {}

		/**
		 * @function StoryAPI#leaveShareState
		 */
		leaveShareState() {}

		/**
		 * @function StoryAPI#moveSceneLeft
		 * @param id
		 */
		moveSceneLeft(id) {
			void(id);
		}

		/**
		 * @function StoryAPI#moveSceneRight
		 * @param id
		 */
		moveSceneRight(id) {
			void(id);
		}

		/**
		 * @function StoryAPI#nextScene
		 * @param options
		 */
		nextScene(options) {
			void(options);
		}

		/**
		 * @function StoryAPI#previousScene
		 */
		previousScene() {}

		/**
		 * @function StoryAPI#renameScene
		 * @param id
		 * @param title
		 */
		renameScene(id, title) {
			void(id);
			void(title);
		}

		/**
		 * @function StoryAPI#selectScene
		 * @param options
		 */
		selectScene(options) {
			void(options);
		}

		/**
		 * @function StoryAPI#setCurrentTime
		 * @param time
		 */
		setCurrentTime(time) {
			void(time);
		}

		/**
		 * @function StoryAPI#enterPrintMode
		 */
		enterPrintMode() {}

		/**
		 * @function StoryAPI#leavePrintMode
		 * @param sceneTime
		 */
		leavePrintMode(sceneTime) {
			void(sceneTime);
		}
	}

	return StoryAPI;
});
